import styled from 'styled-components';
import { Format, BaseStyledComponentProps, navBarHeight } from '../../../utils/styles-constants';
import { MenuPosition } from '../../../typings/menu';

const StyledHeader = styled('div')`
	position: absolute;
	top: 0;
	right: 0;
	left: 0;
	z-index: 5;
	display: flex;
	box-sizing: border-box;
	padding-left: 22px;
	padding-right: 12px;
	width: 100%;
	border: 0;
	height: ${navBarHeight};
	align-items: center;
	};

	${(props: BaseStyledComponentProps) => props.theme.primary.spacerColor && `border-bottom: 1px solid ${props.theme.primary.spacerColor};`};

	> * {
		flex-grow: 1;
		flex-basis: 33%;
	}

	@media ${Format.Smartphone} {
		padding: 0 5px;
	}
`;

interface StyledHeaderSectionProps {
	position: MenuPosition;
}

const StyledHeaderSection = styled('div')`
	flex-grow: 1;
	flex-basis: 33%;
	display: flex;
	flex-wrap: nowrap;
	align-items: center;
	${(props: StyledHeaderSectionProps) => {
		switch (props.position) {
			case MenuPosition.center:
				return `justify-content: center;`;
			case MenuPosition.right:
				return 'justify-content: flex-end;';
			case MenuPosition.left:
			default:
				return 'justify-content: flex-start;';
		}
	}}
`;

const PageTitle = styled('div')`
	display: flex;
	justify-content: center;
`;

export { PageTitle, StyledHeaderSection, StyledHeader };


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/MenuManager/Header/styles.ts